import mobx, {
	observable,
	action,
	computed
} from 'mobx';
import _ from 'lodash';
import api from '../../api';
// import lineStore from './line';

export default class Schedule {
	store = null;
	LS_KEY = 'live_schedule_menu';
	@observable status = false;
	@observable isLoading = true;
	@observable dict = {};
	@observable league = {};
	@observable menu = {};
	@observable schedule = {};
	@observable sort = {};
	@observable sport = {};
	@observable timeline = [];
	@observable order = [];
	@observable select = {
		sort: 'time', // сортировка по времени 'time' или алфавиту 'abc' 
		time: 0, // сортировка по времени 7200 - показываь за 2 часа
		sport: [], //выбранные виды спорта, по умолчанию все,
		allSport: 0
	};
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};

	constructor(store) {
		this.store = store;
	}

	@action despose() {
		this.status = false;
		this.isLoading = true;
		this.dict = {};
		this.league = {};
		this.menu = {};
		this.schedule = {};
		this.sort = {};
		this.sport = {};
		this.timeline = [];
		this.clearResult();
	}

	@action init() {
		this.status = true;
		if (!Object.keys(this.schedule).length) {
			this.getData();
		}
		const ls = JSON.parse(localStorage.getItem(this.LS_KEY));
		if (ls) {
			this.select = {...this.select, sort: ls.sort, time: ls.time, sport: ls.sport, allSport: ls.allSport};
		}
	}

	@action setResult(text, type) {
		this.result.status = 1,
		this.result.text = text,
		this.result.type = type ? type : 0;
	}

	@action clearResult() {
		this.result.status = 0 ,
		this.result.text = '',
		this.result.type = 0;
	}

	@action getData() {
		return api[this.store.mode].getSchedule().then(
			action(
				data => {
					if (data.code == "OK") {
						this.dict = data.result.dict ? data.result.dict : {};
						this.league = data.result.league ? data.result.league : {};
						this.menu = data.result.menu ? data.result.menu : {};
						this.schedule = data.result.schedule ? data.result.schedule : {};
						this.sort = data.result.sort ?  data.result.sort : {};
						this.sport = data.result.sport ? data.result.sport : {};
						this.timeline = data.result.timeline ? data.result.timeline : [];
						if (!this.select.sport.length) {
							this.selectSport(1);
						} else {
							this.print();
						}
					} else {
						this.setResult(data.text ? data.text : 'SERVER_TEMPORARILY_DOWN');
					}
				})
			)
			.catch(action(err => {
				this.setResult('SERVER_TEMPORARILY_DOWN');
			}))
			.finally(action(() => {
				this.isLoading = false;
			}));
	}

	safeLs() {
		localStorage.setItem(this.LS_KEY, JSON.stringify(this.select));
	}

	@action selectSport(type, id) {
		switch(type) {
			case 1:
				this.select.allSport = !this.select.allSport;
				if (this.select.allSport && this.menu.order) {
					this.select.sport = mobx.toJS(this.menu.order);
				} else {
					this.select.sport = [];
				}
				break;
			case 2:
				const idx = this.select.sport.indexOf(id);
				if (idx == -1) {
					this.select.sport.push(id);
					_.xor(this.select.sport.peek(), mobx.toJS(this.menu.order)).length == 0 ? this.select.allSport = 1 : null;
				} else {
					this.select.sport.splice(idx, 1);
					this.select.allSport = 0;
				}
				break;
		}
		this.print();
		this.safeLs();
	}

	@action setTime(time) {
		if (this.select.time !== time ){
			this.select.time = time; 
		}
		this.print();
		this.safeLs();
	}

	@action setSort(sort) {
		this.select.sort = sort; 
		this.print();
		this.safeLs();
	}

	@action checkTime(time) {
    let date, days_between, time_date,
        cur_date = new Date(),
        cur_time = cur_date.getTime(),
        check = 1,
        timeline = this.select.time;

    time = parseInt(time);
    date = new Date(time);

    if (time < cur_time) {
        check = 0;
    }
    if (timeline >= 86400) {
        days_between = (timeline / 86400) - 1;
        time_date = (new Date(cur_time + (86400000 * days_between)));
        if (date.getMonth() != time_date.getMonth()) {
            check = 0;
        }
        if (date.getDate() != time_date.getDate()) {
            check = 0;
        }
    }
    else if (timeline > 0 && (time - cur_time) / 1000 > timeline) {
        check = 0;
    }

    return check;
  }

  print() {
      let i, time, sid, lid, sch_id, sid_lid, game;
      this.order = [];

      if (!Object.keys(this.schedule).length) { return; }

      if (this.select.sort == 'time') {
        for(time in this.sort.time) {
          time = parseInt(time);
          if (this.checkTime(time * 1000) == 0) {
              continue;
          }

          for(sch_id of this.sort.time[time]) {
          	game = this.schedule[sch_id];
            if (!game) { continue; }
            sid = game.sid;
            if (this.checkSport(sid) == 0) {
                continue;
            }

            this.order.push(sch_id);
          }
        }
      } else if (this.select.sort == 'abc') {
          let j, k;
          for(sid of this.sort.alphabet.sport) {
              if (this.checkSport(sid) == 0) {
                  continue;
              }
              for(lid of this.sort.alphabet.league[sid]) {
                  for(sch_id of this.sort.alphabet.schedule[sid][lid]) {
                    time = this.schedule[sch_id].time;
                    time = parseInt(time);
                    if (this.checkTime(time * 1000) == 0) {
                        continue;
                    }

                    this.order.push(sch_id);
                  }
              }
          }
      }
      // return order;
      // this.show();
      // this.saveToLs();
  }

  @action checkSport(sid) {
      sid = parseInt(sid);

      const is_other = this.menu.other.indexOf(sid) != -1 && this.select.sport.indexOf('other') != -1
      const is_main = this.select.sport.indexOf(sid) != -1;

      return is_main || is_other;
  }
}


// WEBPACK FOOTER //
// ./src/stores/lineStore/schedule.js